import { Dispatch, SetStateAction } from 'react';

export type AuthModalProps = {
  closeClick: () => void;
  toggleSupervisorOverride: Dispatch<SetStateAction<boolean>>;
  dataTestId?: string;
  success?: (info: { firstName: string, lastName: string }) => void;
};

export type formDataType = {
  email: string;
  password: string;
  remember: boolean;
};

export const defaultValues = {
  email: '',
  password: '',
  remember: false,
};
